import graphService, { graphServiceBeta } from '@ane/core/lib/services/GraphService';
import envService from '@ane/core/lib/services/EnvironmentService';
import { actionClass } from '../ReduxDecorators';
import * as _ from 'lodash';
import { cache } from '@ane/core/lib/services/PromiseCache';
import { isGuid } from '@ane/core/lib/utils/CommonStringUtils';

@actionClass
export class GraphActions {
  @cache()
  public async checkSecurityGroup(group: string) {
    const adGroup = await graphService.getGroupByNickname(group);
    let isMember = false;
    if (!!adGroup) {
      const securityCheck = await graphService.checkMemberGroups(envService.getUser().upn, [adGroup.id]);
      isMember = !!_.find(securityCheck.getSuccessData().value, (p) => p === adGroup.id);
    }
    return {
      group,
      isMember,
    };
  }

  @cache(true)
  public async getUser(id: string) {
    const user = await graphService.getUserInfo(id);
    return { id, user: user || null };
  }

  @cache(true)
  public async getGroup(id: string) {
    const group = await graphService.getGroupByNickname(id);
    let result = group;
    if (!result && isGuid(id)) {
      result = await graphService.getGroupById(id);
    }
    return { id, group: result || null };
  }

  @cache(true)
  public async getUserImage(upn: string) {
    const image = await graphService.getUserImage(upn);
    return { upn, image: image.isSuccessful() && image.getSuccessData() };
  }

  @cache(true)
  public async getApp(appId: string) {
    const app = await graphServiceBeta.getAppInfoByAppId(appId);
    return { appId, app: app || null };
  }

  @cache(true)
  public async getAppImage(appId: string) {
    const image = await graphServiceBeta.getAppImage(appId);
    return { appId, image: image && image.isSuccessful() && image.getSuccessData() };
  }
}

export default new GraphActions();
